import { render, staticRenderFns } from "./SetArea.vue?vue&type=template&id=2f642c9e&scoped=true&"
import script from "./SetArea.vue?vue&type=script&lang=js&"
export * from "./SetArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f642c9e",
  null
  
)

export default component.exports